const baseURL = "https://frontend-take-home-service.fetch.com";

export default baseURL;
